import React, { FC, ReactNode } from "react";
import { View, Text, ITouchEvent } from "@tarojs/components";
import classNames from "classnames";
import { StandardLonghandProperties } from "csstype";
import { XHComponentCommonProps } from "../../types";

import "./index.scss";

export type XHCellProps = {
  content?: ReactNode;
  contentDescription?: ReactNode;
  description?: ReactNode;
  subDescription?: ReactNode;
  paddingHorizontal?: boolean;
  icon?: ReactNode;
  value?: ReactNode;
  extraIcon?: ReactNode;
  border?: boolean;
  arrow?: boolean;
  outline?: boolean;
  onClick?: (e: ITouchEvent) => void;
  descriptionColor?: StandardLonghandProperties["color"];
  valueColor?: StandardLonghandProperties["color"];
  ellipsis?: boolean;
  placeholder?: string;
  alignItems?: "start" | "center" | "end";
  /**
   * @description 是否是次级列表
   */
  secondary?: boolean;
  dataTrackId?: string;
} & XHComponentCommonProps;

const XHCell: FC<XHCellProps> = props => {
  const {
    icon,
    value,
    extraIcon,
    arrow,
    border = true,
    paddingHorizontal = true,
    onClick,
    className,
    outline = true,
    descriptionColor = "",
    valueColor,
    ellipsis = true,
    content,
    contentDescription,
    description,
    subDescription,
    secondary,
    alignItems = icon ? "start" : "center",
    placeholder = "",
    dataTrackId = "Cell",
  } = props;

  const cellcls = classNames(
    "xh-cell",
    { border },
    { secondary },
    { outline },
    { paddingHorizontal },
    alignItems,
    className
  );

  const mainCls = classNames("xh-cell-main", {
    ellipsis,
  });

  const handleClick = (e: ITouchEvent) => {
    onClick && onClick(e);
  };

  return (
    <View
      className={cellcls}
      onClick={handleClick}
      // @ts-ignore
      dataTrackId={`${dataTrackId}_wrapper`}
    >
      {icon && <View className="xh-cell-icon">{icon}</View>}
      <View
        className={mainCls} // @ts-ignore
        dataTrackId={`${dataTrackId}_main`}
      >
        {content && <View className="xh-cell-main-content">{content}</View>}
        {contentDescription && (
          <View className="xh-cell-main-description">{contentDescription}</View>
        )}
      </View>
      <View
        className="xh-cell-description"
        // @ts-ignore
        dataTrackId={`${dataTrackId}_description`}
        style={{ color: descriptionColor }}
      >
        {description ? (
          <View>{description}</View>
        ) : (
          <View className="xh-cell-description-placeholder">{placeholder}</View>
        )}
        <Text className="xh-cell-description-sub">{subDescription}</Text>
      </View>
      <View
        className="xh-cell-value"
        // @ts-ignore
        dataTrackId={`${dataTrackId}_value`}
      >
        <View className="xh-cell-value-info" style={{ color: valueColor }}>
          {value}
        </View>
        <View className="xh-cell-value-icon">
          {extraIcon
            ? extraIcon
            : arrow && <View className="xh-cell-value-icon-arrow" />}
        </View>
      </View>
    </View>
  );
};
export default XHCell;
